import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class DostavnicaService {
  constructor(private _http: HttpClient) {}

  dohvatiDostavnice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_dostavnice', a)
      .pipe(map((res: any) => res));
  }

  dostavnicaDetalji(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dostavnica_detalji', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJednuDostavnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jednu_dostavnicu_web', a)
      .pipe(map((res: any) => res));
  }

  kreirajDostavnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'kreiraj_dostavnicu', a)
      .pipe(map((res: any) => res));
  }

  urediZaglavljeDostavnice(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'ured_dostavnicu', a)
      .pipe(map((res: any) => res));
  }

  urediStavkuDostavnice(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'uredi_stavke_dostavnice', a)
      .pipe(map((res: any) => res));
  }

  obrisiStavkuDostavnice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'brisanje_dostavnica_stavka', a)
      .pipe(map((res: any) => res));
  }

  dostavnicaObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dostavnicaObrisi', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPrijevoznike(a: any){
    return this._http
    .post(AppConfig.ipAddress + 'dohvati_prijevoznike', a)
    .pipe(map((res: any) => res ));
  }

  poslovnicaPopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPoslovniceTomo(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_poslovnicepartnera_tomo', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPartnere(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'partnerPopisOtpremaMobitel', a)
      .pipe(map((res: any) => res));
  }

  partnerPopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'partner_popis', a)
      .pipe(map((res: any) => res));
  }

  odobriDostavnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'odobri_dostavnicu_i_kreirajdokumente', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProizvode(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_artikle', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveLotove(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'provjeri_lot', a)
      .pipe(map((res: any) => res));
  }

  dodajNoveStavkePalete(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dodaj_paletu_izlaz', a)
      .pipe(map((res: any) => res));
  }

  povezani_dokumenti_popis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'povezani_dokumenti_popis', a)
      .pipe(map((res: any) => res));
  }

  neobradeneNarudzbe_otpremarobe(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'neobradenenarudzbe_otpremarobe', a)
      .pipe(map((res: any) => res));
  }

  provjeri_sscc(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'provjeri_sscc', a)
      .pipe(map((res: any) => res));
  }
}
